import { useEffect, useState } from "react";
import { getHolidays } from "../api";

const cache = {};

/** Map "YYYY-MM-DD" -> nom du jour férié, pour les années demandées. */
export const useHolidays = (years) => {
  const key = [...new Set(years.filter(Boolean))].sort().join(",");
  const [map, setMap] = useState({});
  useEffect(() => {
    if (!key) return;
    let alive = true;
    Promise.all(key.split(",").map((y) => cache[y] || (cache[y] = getHolidays(y).then((r) => r.data.holidays).catch(() => { delete cache[y]; return []; }))))
      .then((lists) => { if (alive) setMap(Object.fromEntries(lists.flat().map((h) => [h.date, h.nom]))); });
    return () => { alive = false; };
  }, [key]);
  return map;
};

export const holidayOf = (map, dateStr) => (dateStr ? map[String(dateStr).slice(0, 10)] : undefined);

/** Texte des avertissements renvoyés par l'API (chevauchements) pour un toast. */
export const overlapText = (warnings) => {
  const ov = warnings?.overlaps || [];
  if (!ov.length) return null;
  return ov.map((o) => `${o.collaborateurs.join(", ")} : chevauche « ${o.with.client_nom} » (${String(o.with.date).slice(11, 16)})`).join(" · ");
};
